import * as types from './types';

export const setViewerSessionsParams = (params) => ({
  type: types.SET_VIEWER_SESSIONS_PARAMS,
  params,
});

export const updateSelectedMetrics = (
  newMetrics,
  name,
  anchoredMetrics: Record<string, boolean> | undefined = undefined,
) => ({
  type: types.UPDATE_SELECTED_METRICS,
  newMetrics,
  anchoredMetrics,
  name,
});

export const updateMetricAnchor = (metric, name) => ({
  type: types.UPDATE_METRIC_ANCHOR,
  metric,
  name,
});

export const getScanData = ({ filter, from, to, name, metric, metricFilter }) => ({
  type: types.GET_SCAN_DATA,
  filter,
  from,
  to,
  name,
  metric,
  metricFilter,
});

export const updateScanTableColumns = (newColumns, name) => ({
  type: types.UPDATE_TABLE_COLUMNS,
  newColumns,
  name,
});

export const changeTimeLimit = (limit, name) => ({
  type: types.CHANGE_TIME_LIMIT,
  limit,
  name,
});

export const changeFuncData = (newFuncData, name) => ({
  type: types.CHANGE_FUNC_DATA,
  newFuncData,
  name,
});

export const setDataType = (dataType, name) => ({
  type: types.SET_DATA_TYPE,
  dataType,
  name,
});

export const addTableData = (code) => ({
  type: types.ADD_TABLE_DATA,
  code,
});
